module.exports = __webpack_public_path__ + "static/rcc-orr-mobile-a2e4ff3e4ad0c5b6b4d8c4d477336eef.png";